module.exports = __webpack_public_path__ + "img/042-043.407f8b0d.jpg";